
import axiosApi from '@/request/index'
import Icon from 'vux/src/components/icon/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import HeadNav from '@/components/headNav'
import FooterNav from '@/components/footerNav'

export default {
name:"Search",
components:{
Icon,
HeadNav,
FooterNav
},
data(){
return{
searchContent:"",
title:'素材',
imgUrl:HTTP_IMG_URL,
offset:1,
start:0,
size: 5,
hasMoreData:true,
discoverList:[],
bigImgShow:false,
bigImg:''
}
},
activated() {
this.$store.commit('savePageType',2)
const scrollTop = this.$route.meta.scrollTop;
const $content = document.querySelector('#content');
if (scrollTop && $content) {
$content.scrollTop = scrollTop;
}
},
created(){
this.$store.commit('savePageType',2)
this.fetchList()
},
mounted() {
var self = this
document.getElementById('content').onscroll = function () {

var scrollTop = document.getElementById('content').scrollTop

var windowHeight = document.getElementById('content').clientHeight

var scrollHeight = document.getElementById('content').scrollHeight

if (scrollTop + windowHeight == scrollHeight && self.hasMoreData == true) {
self.fetchList()
}
}
},
methods:{
search(){
console.log('111')
this.size = 5;
this.start = 0;
this.offset =1;
this.hasMoreData = true;
this.discoverList = [];
this.fetchList()
},

saveImg(){
this.$vux.toast.show({
text: '下载成功'
})
},
copyText(){
this.$vux.toast.show({
text: '复制成功'
})
},
closeImg(){
this.bigImgShow = false;
},
showBigImg(img){
this.bigImg = img
this.bigImgShow = true;
},

fetchList(clear) {
var param = {
"size": this.size,
"start": this.start ,
"orderRules": [{ "orderKey": "isTop", "desc": true }, { "orderKey": "crtTime", "desc": true }],
"desc": true,
"message": this.searchContent
};
axiosApi.getDiscoverList(param).then(res => {
if (res.code == 0) {
let data = res.content;
if(data!=null&&data.list!=null){
data.list.forEach(discoverItem => {
discoverItem.crtTime = this.dateDiff(discoverItem.crtTime);
});
}
this.discoverList=this.discoverList.concat(data.list)
var offset = this.offset;
var hasMore = true;
if (this.discoverList.length < data.total) {
offset = this.offset + 1,
hasMore = true
} else {
hasMore = false
}
this.hasMoreData = hasMore;
this.offset = offset;
this.start = (offset - 1) * this.discoverList.length
}
});
},
dateDiff :function (dateString) {
if (!dateString){
return '';
}
var timestamp = Date.parse(dateString.replace(/-/gi, "/"));

var arrTimestamp = (timestamp + '').split('');
for (var start = 0; start < 13; start++) {
if (!arrTimestamp[start]) {
arrTimestamp[start] = '0';
}
}
timestamp = arrTimestamp.join('') * 1;

var minute = 1000 * 60;
var hour = minute * 60;
var day = hour * 24;
var halfamonth = day * 15;
var month = day * 30;
var now = new Date().getTime();
var diffValue = now - timestamp;


if (diffValue < 0) {
return '刚刚';
}


var yearC =  diffValue / (month * 12);
var monthC = diffValue / month;
var dayC = diffValue / day;
var hourC = diffValue / hour;
var minC = diffValue / minute;


var zero = function (value) {
if (value < 10) {
return '0' + value;
}
return value;
};


if (yearC >=1) {

return parseInt(yearC) + "年前";
} else if (monthC >= 1) {
return parseInt(monthC) + "月前";
} else if (dayC >= 1) {
return parseInt(dayC) + "天前";
} else if (hourC >= 1) {
return parseInt(hourC) + "小时前";
} else if (minC >= 1) {
return parseInt(minC) + "分钟前";
}
return '刚刚';
},
}

}



// WEBPACK FOOTER //
// ./src/pages/discover/index.vue